const about = (state) => `<section id='about' class='wrapper '>
<h3 class='mt-6'>${state.aboutTitle}</h3>
<p class='mt-2'>${state.aboutCopy}</p>
<div class="row justify-content-center mb-5">
  <a href=${state.cvUrl} class='mt-6 button' target="_blank">${state.textButton}
    <i class='ml-1'>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12"><path d="M13,6.234H10.144V2H5.856V6.234H3l5,4.941ZM3,12.587V14H13V12.587Z" transform="translate(-3 -2)" fill="#fff"/></svg>
    </i>
  </a>
</div>
</section>`

export default about
